/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load GA4 premium event listeners
 * */

// user log in event
jQuery(document).on("pmw:login", () => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!wpm.googleConfigConditionsMet({type: "statistics"})) return;

		const data = {
			send_to: wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
		};

		wpm.gtagLoaded().then(() => {
			gtag("event", "login", data);
			pmw.console.log("Google Analytics: login event sent", data);
		});
	} catch (e) {
		console.error(e);
	}
});


/**
 * Scroll tracking event
 */

jQuery(document).on("pmw:scroll-depth", (event, scrollEvent) => {

	if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
	if (!wpm.googleConfigConditionsMet({type: "statistics"})) return;

	const data = {
		send_to: wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
		value  : scrollEvent.threshold,
	};

	wpm.gtagLoaded().then(() => {
		gtag("event", "scroll", data);
		pmw.console.log("Google Analytics: scroll event sent", data);
	});
});

/**
 * Attach an event listener to all links that contain tel: links
 */
jQuery(document).on("click", "a[href^='tel:']", (event) => {

	// Get the phone number from the link
	let phoneNumber = event.target.href.replace("tel:", "");

	// Trim the phone number and remove all whitespaces
	phoneNumber = phoneNumber.replace(/\s/g, "");

	const data = {
		send_to             : wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
		clicked_phone_number: phoneNumber,
	};

	wpm.gtagLoaded().then(() => {
		gtag("event", "phone_number_click", data);
		pmw.console.log("Google Analytics: phone_number_click event sent", data);
	});
});

/**
 * Attach an event listener to all links that contain mailto: links
 */
jQuery(document).on("click", "a[href^='mailto:']", event => {

	const data = {
		send_to      : wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
		clicked_email: wpm.getEmailFromTarget(event.target),
	};

	wpm.gtagLoaded().then(() => {
		gtag("event", "email_click", data);
		pmw.console.log("Google Analytics: email_click event sent", data);
	});
});

// Track load time in GA4 in seconds
// https://www.lovesdata.com/blog/page-load-google-analytics
jQuery(() => {
	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.page_load_time_tracking) return;

		const msToSeconds = number => {
			// Round to 2 decimal places
			return Math.round((number / 1000) * 100) / 100;
		};

		const msRound = number => {
			// Round to the nearest integer
			return Math.round(number);
		};

		// Check if lazy loading is enabled
		const isLazyLoaded = !!wpmDataLayer?.general?.lazy_load_pmw;


		// Capture the load time immediately only if not lazy loaded
		const timeToLoadSeconds = !isLazyLoaded ? msToSeconds(performance.now()) : null;
		const timeToLoad        = !isLazyLoaded ? msRound(performance.now()) : null;

		// Use setTimeout to ensure Navigation Timing metrics are fully populated
		setTimeout(() => {
			const perfData = performance.getEntriesByType("navigation")[0];
			const data     = {
				send_to        : wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
				dom_complete   : msRound(perfData.domComplete),
				dom_interactive: msRound(perfData.domInteractive),
				load_complete  : msRound(perfData.loadEventEnd),

				// Time to First Byte
				ttfb: msRound(perfData.responseStart - perfData.requestStart),

				// DOM Content Loaded
				dom_content_loaded: msRound(perfData.domContentLoadedEventEnd),

				// Network timing metrics
				dns_time       : msRound(perfData.domainLookupEnd - perfData.domainLookupStart),
				connection_time: msRound(perfData.connectEnd - perfData.connectStart),
				response_time  : msRound(perfData.responseEnd - perfData.responseStart),

				// Processing breakdowns
				document_processing: msRound(perfData.domComplete - perfData.responseEnd),
				total_page_load    : msRound(perfData.loadEventEnd - perfData.startTime),

				// Redirect information
				redirect_time : msRound(perfData.redirectEnd - perfData.redirectStart),
				redirect_count: perfData.redirectCount,
			};

			// Only add timeToLoad to the data object if not lazy loaded
			if (!isLazyLoaded) {
				data.page_load_time_seconds = timeToLoadSeconds;
				data.page_load_time         = timeToLoad;
			}

			wpm.gtagLoaded().then(() => {
				gtag("event", "page_load_time", data);
				pmw.console.log("Google Analytics: page_load_time event sent", data);
			});
		}, 0);
	} catch (e) {
		pmw.console.error("Error setting up page_load_time tracking", e);
	}
});
